import AttrItem from "./attr-item.vue";
import { pickBy } from '@/utils'
export const generateUniqueStrings =(count, length) => {
  const uniqueStrings = new Set();

  while (uniqueStrings.size < count) {
    let str = '';
    const possibleCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      str += possibleCharacters.charAt(Math.floor(Math.random() * possibleCharacters.length));
    }

    if (!uniqueStrings.has(str)) {
      uniqueStrings.add(str);
    }
  }
  return [...uniqueStrings];
}

const config = {
  name: "HmNavigationTabs",
  setting: [
    {
      label: 'Tabs',
      key: 'data',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} />
      },
      value: [
        {
          id: generateUniqueStrings(1, 5)[0],
          title: 'Tab',
          children: []
        }
      ]
    }
  ],
  transformIn: (v) => {
    const {
      name,
      base,
      config
    } = v
    return {
      name,
      ...base,
      ...config
    }
  },
  transformOut:(v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
        })
      },
      config: (v) => {
        return pickBy(v, {
          data: 'data',
        })
      }
    })
  }
}
export default config;
